// Cargar Swiper y Pagination una sola vez para mejorar el rendimiento
let SwiperConstructor;
let PaginationModule;

async function loadSwiperAndPagination() {
  if (!SwiperConstructor || !PaginationModule) {
    try {
      // Asume que 'flu.chunks.swiper' es una ruta válida a tu paquete Swiper
      const { Swiper, Pagination } = await import(flu.chunks.swiper);
      SwiperConstructor = Swiper;
      PaginationModule = Pagination;
    } catch (error) {
      console.error("Error al cargar Swiper o el módulo de paginación:", error);
      return false;
    }
  }
  return true;
}

function setupSwiperPagination(swiperElement) {
  const swiper = swiperElement.swiper;

  // Si no hay instancia de Swiper o ya tiene paginación, salimos
  // Añadimos una verificación de si ya lo hemos procesado para evitar reprocesar
  if (!swiper || swiperElement.dataset.paginationEnabled === 'true' || swiper.params.pagination) {
    return;
  }

  // Guardamos la referencia de los parámetros originales
  const originalParams = {
    ...swiper.params, // Copiamos todos los parámetros existentes
    modules: []
  };

  // Agregar la nueva configuración de paginación
  originalParams.pagination = {
    el: ".swiper-pagination",
    clickable: true,
    type: 'bullets'
  };

  // Aseguramos que el módulo de paginación esté incluido
  if (PaginationModule) {
    originalParams.modules.push(PaginationModule);
  } else {
    console.warn("Módulo de paginación no cargado. No se puede habilitar la paginación.");
    return;
  }

  try {
    // Destruimos el swiper anterior de forma segura
    swiper.destroy(true, true);

    // Creamos el swiper nuevo
    new Swiper(swiperElement, originalParams);

    // Marcamos el elemento como procesado
    swiperElement.dataset.paginationEnabled = 'true';
    console.log("Paginación de Swiper habilitada y actualizada:", swiperElement);

  } catch (e) {
    console.error("Error al destruir o recrear el Swiper:", e);
  }
}


function enableMobilePaginationOnSwipers() {
  const isMobile = window.innerWidth <= 768;
  if (!isMobile) return;

  // Carga los módulos de Swiper una sola vez
  loadSwiperAndPagination().then(success => {
    if (!success) return;

    // Usamos un observador para detectar cuándo los Swipers aparecen en el DOM
    const observer = new MutationObserver((mutations) => {
      mutations.forEach(mutation => {
        if (mutation.type === 'childList' && mutation.addedNodes.length > 0) {
          mutation.addedNodes.forEach(node => {
            if (node.nodeType === 1 && node.matches('.multi-column__inner.swiper')) {
              // Si el nodo añadido es un swiper, intentamos configurarlo
              // Es importante dar un pequeño delay si el Swiper se inicializa asíncronamente
              setTimeout(() => setupSwiperPagination(node), 100);
            } else if (node.nodeType === 1) {
              // También buscamos Swipers dentro de los nodos añadidos (subtree)
              node.querySelectorAll('.multi-column__inner.swiper').forEach(swiperElement => {
                setTimeout(() => setupSwiperPagination(swiperElement), 100);
              });
            }
          });
        }
      });
    });

    // Observa un contenedor más específico si es posible, o body como último recurso
    // Considera observar un elemento padre que contenga todos los swipers para mayor eficiencia
    observer.observe(document.body, { // Cambia document.body por un contenedor más específico si existe
      childList: true,
      subtree: true // Necesario para detectar Swipers anidados
    });

    // También procesa los Swipers que ya existen en el DOM al cargar la página
    document.querySelectorAll('.multi-column__inner.swiper').forEach(swiperElement => {
      setTimeout(() => setupSwiperPagination(swiperElement), 100);
    });

  });
}

// Event listener para la carga inicial del DOM
document.addEventListener('DOMContentLoaded', () => {
  enableMobilePaginationOnSwipers();
});

// Event listener para cambios de tamaño de ventana
let wasMobile = window.innerWidth <= 768;
window.addEventListener('resize', () => {
  const isNowMobile = window.innerWidth <= 768;
  if (isNowMobile && !wasMobile) {
    // Si pasamos a móvil, habilitamos la paginación en los nuevos Swipers
    enableMobilePaginationOnSwipers();
  } else if (!isNowMobile && wasMobile) {
    // Opcional: Si se pasa de móvil a escritorio, podrías considerar
    // deshabilitar la paginación o restaurar el Swiper original si es necesario.
    // Esto implicaría un proceso inverso de recreación.
    // Por simplicidad, no lo incluyo aquí, pero es una consideración importante.
    console.log("Se pasó a escritorio. Los Swipers con paginación móvil permanecen.");
  }
  wasMobile = isNowMobile;
});